// ES2024 polyfills for older Safari / Android WebViews. Must be imported first
// so these globals exist before bundled/dynamically-imported code (react-pdf) runs.

type WithResolversResult<T> = {
  promise: Promise<T>;
  resolve: (value: T | PromiseLike<T>) => void;
  reject: (reason?: unknown) => void;
};

const promiseWithResolvers = Promise as unknown as {
  withResolvers?: <T>() => WithResolversResult<T>;
};

if (typeof promiseWithResolvers.withResolvers !== "function") {
  promiseWithResolvers.withResolvers = <T>(): WithResolversResult<T> => {
    let resolve!: (value: T | PromiseLike<T>) => void;
    let reject!: (reason?: unknown) => void;
    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

const urlWithParse = URL as unknown as {
  parse?: (url: string | URL, base?: string | URL) => URL | null;
};

if (typeof urlWithParse.parse !== "function") {
  urlWithParse.parse = (url, base) => {
    try {
      return new URL(url, base);
    } catch {
      return null;
    }
  };
}

export {};
